import moment from "moment/moment";
import request from "@/utils/request";
// const list = () => {
//   const iqueryParam =  'RAD.GetDataListByTypeCodeAndTimes|1|String;MDBZ_RADDATA2_P|' +
//     'DateTime;' + moment().subtract(6, 'hours').format('YYYY-MM-DD HH:mm:ss') +
//     '|DateTime;' + moment(new Date()).format('YYYY-MM-DD HH:mm:ss') +
//     '|Int32;20|Int32;-1'
//   const params = {
//     calltype: 4,
//     iquery: iqueryParam,
//   }
//   // 湖南
//   // return request.get(`/img_radar/10/${paramData}`).then((data: any) => {
//   //   if (!data || data.length === 0) {
//   //     return []
//   //   }
//   //   return data
//   // })
//   // 陕西
//   // return request.get('/Weather/RAD.aspx', params).then((data: any) => {
//   //   if (!data || !data.Rows || data.Rows.length === 0) {
//   //     return []
//   //   }
//   //   // console.log(data.Rows)
//   //   return data.Rows.reverse()
//   // })
//   // 全国
//   return request.get('/radar/imgs.php?type=radar', null).then((data: any) => {
//     // console.log(data)
//     if (!data || data.status !== 'ok' || !data.radar_img || data.radar_img.length === 0 ) {
//       return []
//     }
//     const result: any[] = []
//     for (const ri of data.radar_img) {
//       result.push({
//         FILEPATH: ri[0],
//         PRODUCTTIME: moment(ri[1] * 1000).format('YYYY-MM-DD HH:mm:ss'),
//         MINLAT: ri[2][0],
//         MINLON: ri[2][1],
//         MAXLAT: ri[2][2],
//         MAXLON: ri[2][3],
//       })
//     }
//     return result
//   })
// }
const list = () => {
  const params = { productType: 'shaanxiRadar', date: moment().format('YYYYMMDD'), }
  return request.get('/wdt_qiniu_rest/product', params).then((data: any) => {
      if (!data || data.length === 0) return
      return data
  }).catch((err: any) => {
      console.log(err)
    return []
  })
};
const listAll = () => {
  const iqueryParam =
    "RAD.GetDataListByTypeCodeAndTimes|1|String;MDBZ_RADDATA2_P|" +
    "DateTime;" +
    moment().subtract(6, "hours").format("YYYY-MM-DD HH:mm:ss") +
    "|DateTime;" +
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss") +
    "|Int32;20|Int32;-1";
  const params = {
    calltype: 4,
    iquery: iqueryParam,
  };
  return request.get("/Weather/RAD.aspx", params).then((data: any) => {
    if (!data || !data.Rows || data.Rows.length === 0) {
      return [];
    }
    return data.Rows;
  });
};
const listOther = (id: any) => {
  return request.get(`/img_radar/10/${id}`).then((data: any) => {
    if (!data || data.length === 0) {
      return [];
    }
    const result: any[] = [];
    for (const ri of data) {
      const datetime = ri.datetime + "";
      const reg = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      //转成时间戳
      const dt1 = datetime.replace(reg, "$1-$2-$3 $4:$5:$6");
      const timeStamp = new Date(dt1);
      const time = moment(timeStamp)
        .add(8, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      result.push({
        FILEPATH: "http://124.114.232.106:8788/static/png" + ri.filepath,
        PRODUCTTIME: time,
        MINLAT: ri.radarPupInfo.latMin,
        MINLON: ri.radarPupInfo.lonMin,
        MAXLAT: ri.radarPupInfo.latMax,
        MAXLON: ri.radarPupInfo.lonMax,
      });
    }
    return result;
  });
};
const listImgRadar = () => {
  const iqueryParam =
    "RAD.GetDataListByTypeCodeAndTimes|1|String;MDBZ_RADDATA2_P|" +
    "DateTime;" +
    moment().subtract(6, "hours").format("YYYY-MM-DD HH:mm:ss") +
    "|DateTime;" +
    moment(new Date()).format("YYYY-MM-DD HH:mm:ss") +
    "|Int32;20|Int32;-1";
  const params = {
    calltype: 4,
    iquery: iqueryParam,
  };
  // return request.get('/Weather/RAD.aspx', params).then((data: any) => {
  return request.get(`/img_radar/10/Z9739`).then((data: any) => {
    // console.log(data)
    // if (!data || !data.Rows || data.Rows.length === 0) {
    //   return []
    // }
    if (!data || data.length === 0) {
      return [];
    }
    const result: any[] = [];
    for (const ri of data) {
      result.push({
        FILEPATH: ri[0],
        PRODUCTTIME: moment(ri[1] * 1000).format("YYYY-MM-DD HH:mm:ss"),
        MINLAT: ri[2][0],
        MINLON: ri[2][1],
        MAXLAT: ri[2][2],
        MAXLON: ri[2][3],
      });
    }
    // console.log(result)
    return result;
    // return data.Rows.reverse()
    // return data.reverse()
    // return data
  });
};
const listImgJson = () => {
  return request
    .get("/newwebgis/radar/radar_list_new.json", null)
    .then((data: any) => {
      // console.log(data)
      const strData = data.split('"value":[{')[1];
      const arrData = strData.split("},{");
      // console.log(arrData)
      const newArr = [] as any;
      arrData.map((e: any, index: any) => {
        const path = e.split('"path":["')[1].split('"],"time"')[0];
        const arr = path.split('","');
        // console.log(index)
        // console.log(path)
        // console.log(arr)
        newArr.push(...arr);
      });
      // console.log(newArr)
      const result = [] as any;
      newArr.map((e: any) => {
        const dateStr = e.split("_")[1].split(".")[0];
        // console.log(dateStr)
        result.push({
          FILEPATH: `http://124.70.8.80:8701/newwebgis/radar/${e}`,
          MAXLAT: 53.55,
          MAXLON: 135.05,
          MINLAT: 3.86,
          MINLON: 73.66,
          PRODUCTTIME: moment(dateStr, "YYYYMMDDHHmm").format(
            "YYYY-MM-DD HH:mm:00"
          ),
        });
      });
      // console.log(result)
      return result.reverse();
    });
};
const listStationImgJson = (stationId: any) => {
  return request
    .get("/stationRadar/new_radar/json/a" + stationId + ".json", null)
    .then((data: any) => {
      // console.log(data)
      const strData = data.replace("imgLista" + stationId + "(", "");
      const arrDataStr = strData.substr(0, strData.length - 1);
      const arrData = JSON.parse(arrDataStr);
      const result = [] as any;
      arrData.map((e: any) => {
        const dateStr = e.dt;
        result.push({
          FILEPATH: `http://img.weather.com.cn/new_radar/l/${e.name}`,
          MAXLAT: 29.37,
          MAXLON: 112.03,
          MINLAT: 25.75,
          MINLON: 107.97,
          PRODUCTTIME: moment(dateStr, "YYYYMMDDHHmm").format(
            "YYYY-MM-DD HH:mm:00"
          ),
        });
      });
      // console.log(result)
      return result;
    });
};

const listImgBounds = (stationId: any) => {
  return request
    .get("/stationRadar/radarinfo/img_bounds.json", null)
    .then((data: any) => {
      const strData = data.replace("imgbounds(", "");
      const arrDataStr = strData.substr(0, strData.length - 2);
      // console.log(arrDataStr)
      const arrData = JSON.parse(arrDataStr);
      const getBoundJson = arrData["a" + stationId];
      // const getBoundJson = arrData.'a'+stationId

      // console.log(getBoundJson.bound)

      return getBoundJson.bound;
    });
};

const listRadarProductList = (area: string) => {
  return request
    .get("/jc_radar_product/radar/JC_RADAR_" + area + "_JB_V3.html", null)
    .then((data: any) => {
      let MAXLAT = 52.65381;
      let MAXLON = 137.837694;
      let MINLAT = 22.516565;
      let MINLON = 80.637674;

      // let MAXLAT = 36.415519
      // let MAXLON = 114.211541
      // let MINLAT = 33.195395
      // let MINLON = 106.498474

      // if(area === 'HB'){
      //   MAXLAT = 42
      //   MAXLON = 120
      //   MINLAT = 32
      //   MINLON = 110
      // }else if(area === 'HZ'){
      //   MAXLAT = 36
      //   MAXLON = 118
      //   MINLAT = 24
      //   MINLON = 108
      // }else if(area === 'CHN'){
      //   let MAXLAT = 52.65381
      // let MAXLON = 137.837694
      // let MINLAT = 18.516565
      // let MINLON = 72.637674
      // }

      const strData = data.replace("readerinfo(", "").replace(/'/g, '"');
      const arrDataStr = strData.substr(0, strData.length - 1);
      const arrData = JSON.parse(arrDataStr);
      const result = [] as any;

      const radarArr = arrData.radars.slice(-22, -1);
      radarArr.map((e: any) => {
        const dateStr = e.dt;
        result.push({
          FILEPATH: `https://pi.weather.com.cn/i/product/pic/l/${e.fn1}`,
          MAXLAT: MAXLAT,
          MAXLON: MAXLON,
          MINLAT: MINLAT,
          MINLON: MINLON,
          PRODUCTTIME: moment(dateStr, "YYYYMMDDHHmm").format(
            "YYYY-MM-DD HH:mm:00"
          ),
        });
      });
      return result;
    });
};

export default {
  list,
  listAll,
  listOther,
  listImgRadar,
  listImgJson,
  listStationImgJson,
  listImgBounds,
  listRadarProductList,
};
